module.exports = __webpack_public_path__ + "img/BattleDwarfXmas.4d217142.png";